import { createContext, useContext } from 'react';
import { MODAL_Z_INDEX } from '@constants/modal';

const PopupZIndexContext = createContext(MODAL_Z_INDEX.basePopup);

export const PopupZIndexProvider = PopupZIndexContext.Provider;

// A raised surface renders as a sibling of the one it covers, not inside it, so its level cannot be
// derived from context — hence two rungs rather than a ladder. A surface that is itself raised and needs
// to raise another would need a level of its own.
export const popupZIndexFor = aboveModal => (aboveModal ? MODAL_Z_INDEX.aboveModalPopup : MODAL_Z_INDEX.basePopup);

export const usePopupZIndex = () => useContext(PopupZIndexContext);
